/**
 * Horizontale Scroll-Kontrolle
 */
export function scrollIntoViewHoriz(el, container, align = 'nearest') {
  if (!el || !container) return;

  const elRect = el.getBoundingClientRect();
  const cRect = container.getBoundingClientRect();

  const left = elRect.left - cRect.left + container.scrollLeft;
  const right = left + elRect.width;
  const viewLeft = container.scrollLeft;
  const viewRight = viewLeft + container.clientWidth;

  if (align === 'center') {
    const target = left - (container.clientWidth - elRect.width) / 2;
    container.scrollTo({ left: target, behavior: 'smooth' });
    return;
  }

  if (left < viewLeft) {
    container.scrollTo({ left, behavior: 'smooth' });
  } else if (right > viewRight) {
    container.scrollTo({ left: right - container.clientWidth, behavior: 'smooth' });
  }
}